import ProfileDropdown from './ProfileDropdown'

interface HeaderProps {
  firstName?: string
  onLogout?: () => void
  pageTitle?: string
}

export default function Header({ firstName = 'Profil', onLogout, pageTitle }: HeaderProps) {
  return (
    <div className="flex items-center justify-between w-full">
      {/* Page Title Badge (left) */}
      {pageTitle && (
        <div className="inline-flex items-center px-4 py-2 rounded-lg bg-emerald-500/10 border border-emerald-500/20">
          <span className="text-sm font-bold uppercase tracking-wider text-emerald-400">
            {pageTitle}
          </span>
        </div>
      )}
      
      {/* Spacer if no title */}
      {!pageTitle && <div />}
      
      {/* Profile Dropdown (right) */}
      <ProfileDropdown 
        firstName={firstName} 
        onLogout={onLogout || (() => {})} 
      />
    </div>
  )
}
